import React, { useEffect, useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { OfferBar } from '../components/OfferBar';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { DoloresSection } from '../components/DoloresSection';
import { ProductShowcase } from '../components/ProductShowcase';
import { BeneficiosSection } from '../components/BeneficiosSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ProductEmbed } from '../components/ProductEmbed';
import { BonosSection } from '../components/BonosSection';
import { FAQ } from '../components/FAQ';
import { FooterCTA } from '../components/FooterCTA';
import { UrgencyTimer } from '../components/UrgencyTimer';
import { MetaPixel } from '../components/MetaPixel';
export function EnfocadoLanding() {
  const timelineRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: timelineRef,
    offset: ['start center', 'end center']
  });
  // Set document title
  useEffect(() => {
    document.title = 'ENFOCADO™';
  }, []);
  return <div className="min-h-screen bg-[#0A0A0A] text-white font-sans selection:bg-[#FF6B35] selection:text-black" data-id="element-275">
      <MetaPixel data-id="element-276" />
      <OfferBar data-id="element-277" />
      <Header data-id="element-278" />
      <main data-id="element-279">
        <Hero data-id="element-280" />

        {/* Timeline Container Wrapper */}
        <div className="relative" ref={timelineRef} data-id="element-281">
          {/* Mobile Progress Line */}
          <div className="md:hidden absolute left-4 top-[100px] bottom-[100px] w-1 bg-gray-800 rounded-full z-30" data-id="element-282">
            <motion.div className="w-full bg-[#FF6B35] rounded-full shadow-[0_0_10px_#FF6B35]" style={{
            height: useTransform(scrollYProgress, [0, 1], ['0%', '100%'])
          }} data-id="element-283" />
          </div>

          <DoloresSection data-id="element-284" />
          <ProductShowcase data-id="element-285" />
          <BeneficiosSection data-id="element-286" />
        </div>

        <ProductEmbed data-id="element-287" />
        <UrgencyTimer data-id="element-288" />
        <BonosSection data-id="element-289" />
        <TestimonialsSection data-id="element-290" />
        <FAQ data-id="element-291" />
      </main>
      <FooterCTA data-id="element-292" />
    </div>;
}